import { z } from 'zod';
import { FirestoreTimestamp } from './common.schema.js';
// --- Schemas ---
export const TenantMemberSchema = z.object({
    uid: z.string(),
    role: z.enum(['admin', 'editor', 'viewer', 'guest', 'member']),
    joined_at: FirestoreTimestamp,
    invited_by: z.string().optional()
});
export const TenantConfigSchema = z.object({
    themeId: z.string().optional(),
    brand: z.object({
        name: z.string(),
        logoEmoji: z.string().optional(),
        tagline: z.string().optional(),
        domain: z.string().optional()
    }).optional(),
    colors: z.object({
        primary: z.string().regex(/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/).optional(),
        secondary: z.string().regex(/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/).optional(),
        accent: z.string().regex(/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/).optional()
    }).optional(),
    prompts: z.object({
        analysis: z.string().optional(),
        transformation: z.string().optional()
    }).optional()
});
export const TenantSchema = z.object({
    tenantId: z.string(),
    name: z.string(),
    ownerId: z.string(),
    config: TenantConfigSchema.optional(),
    created_at: FirestoreTimestamp,
    version: z.number().int().positive().default(1)
});
